import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`block text-xs uppercase tracking-[0.28em] text-taupe ${className}`}>
    {children}
  </span>
);
